"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.abstractSimpleModuleUiOptions = exports.AbstractSimpleModuleUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const abstract_module_ui_1 = require("./abstract-module.ui");
/**
 * The abstract class that every simple module's UI **HAS TO** extend.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let AbstractSimpleModuleUi = class AbstractSimpleModuleUi extends abstract_module_ui_1.AbstractModuleUi {
    /**
     * @returns The Vue component that will be used to display the module's content.
     */
    get component() {
        return { template: this.html };
    }
    /**
     * @returns The `module` @Prop converted to the raw HTML.
     */
    get html() {
        let html;
        try {
            html = this.DeMarked.convertObjectsToHTML([this.module]);
            this.onReady();
            return html;
        }
        catch (e) {
            this.onError(e);
            return '';
        }
    }
};
AbstractSimpleModuleUi = __decorate([
    vue_property_decorator_1.Component({
        inheritAttrs: false
    })
], AbstractSimpleModuleUi);
exports.AbstractSimpleModuleUi = AbstractSimpleModuleUi;
/**
 * `ComponentOptions` that every simple module **HAS TO** extend.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.abstractSimpleModuleUiOptions = {
    template: '<component :is="component" />'
};
//# sourceMappingURL=abstract-simple-module.ui.js.map